import React, { useState, useEffect } from 'react';
import { Grid2, TextField, Box, Button, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const ParkingTypesForm = ({ apartmentId, token }) => {
  const { t } = useTranslation();
  const [parkingTypes, setParkingTypes] = useState({
    underground_lot: 0,
    outside_lot: 0,
    garage_lot: 0,
    carport: 0,
    stacked: 0,
    free_parking_area: 0,
    street: 0,
    valet: 0,
    bike_parking: 0,
    ev_charging: 0,
  });
  const [isNewEntry, setIsNewEntry] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchParkingTypes = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/parkingtypes/${apartmentId}/`);
        setParkingTypes(response.data);
        setIsNewEntry(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setIsNewEntry(true);
        } else {
          setError('Error fetching parking types.');
          console.error('Error fetching parking types:', error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchParkingTypes();
  }, [apartmentId]);

  const handleQuantityChange = (field, value) => {
    setParkingTypes((prevTypes) => ({
      ...prevTypes,
      [field]: Number(value),
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}/api/parkingtypes/${apartmentId}/`;

      if (isNewEntry) {
        await axios.post(url, parkingTypes, {
          headers: {
            Authorization: `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
      } else {
        await axios.put(url, parkingTypes, {
          headers: {
            Authorization: `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
      }

      alert('Parking types saved successfully!');
      // Optionally navigate or refresh
      // navigate('/dashboard');
    } catch (error) {
      setError('Failed to save parking types.');
      console.error('Error saving parking types:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid2 container spacing={2}>
      {/* Form Fields Section */}
      <Grid2 container item xs={12} spacing={2}>
        {Object.keys(parkingTypes).map((key) => (
          <Grid2 item xs={12} sm={6} md={2.4} key={key}>
            <Box display="flex" alignItems="center">
              <TextField
                id={`${key}-input`}
                name={key}
                label={t(`parkingTypes.${key}`)}
                type="number"
                value={parkingTypes[key]}
                onChange={(e) => handleQuantityChange(key, e.target.value)}
                fullWidth
                margin="normal"
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Box>
          </Grid2>
        ))}


        {/* Error Message Section */}
        {error && (
          <Grid2 item xs={12}>
            <Typography color="error">{error}</Typography>
          </Grid2>
        )}

        {/* Save Button Section */}
        <Grid2 item xs={12}>
          <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
            Save
          </Button>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default ParkingTypesForm;